const quickLinks = [
  { id: "collections", label: "合集内容构成", icon: "ri-layout-grid-line" },
  { id: "adaptations", label: "题材影视剧", icon: "ri-film-line" },
  { id: "series", label: "系列电影", icon: "ri-stack-line" },
  { id: "recommend", label: "电影推荐", icon: "ri-bookmark-line" },
];

const updateTicker = [
  "邵氏古装片方向 · 片厂时代的银幕初现",
  "《潘金莲之前世今生》· 八十年代文艺重构",
  "九十年代系列影片 · 类型化改编阶段",
  "名著改编剧 · 长篇电视剧版本整理",
];

export default function Hero() {
  return (
    <section id="top" className="w-full">
      {/* 入口条 / 更新条压顶 */}
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="w-full px-4 md:px-8 h-10 flex items-center gap-4 overflow-hidden">
          <span className="shrink-0 inline-flex items-center gap-1.5 text-xs font-label tracking-wide text-accent-400">
            <i className="ri-flashlight-fill"></i>
            合集更新
          </span>
          <div className="min-w-0 flex-1 overflow-hidden">
            <div className="flex gap-6 whitespace-nowrap animate-[marquee_26s_linear_infinite]">
              {[...updateTicker, ...updateTicker].map((t, i) => (
                <span
                  key={`${t}-${i}`}
                  className="text-xs md:text-sm text-background-200/90"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 首屏主体 */}
      <div className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=atmospheric%20Chinese%20ink%20wash%20painting%20of%20old%20style%20courtyard%20and%20red%20lanterns%20in%20mist%2C%20warm%20paper%20texture%2C%20deep%20vermillion%20and%20gold%20accents%2C%20cinematic%20wide%20composition%2C%20artistic%20and%20muted%2C%20no%20text&width=1920&height=1080&seq=pjl-hero-bg&orientation=landscape"
            alt="水墨风格的古宅庭院与灯笼氛围背景"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>

        <div className="relative w-full px-4 md:px-8 py-16 md:py-28">
          <div className="max-w-5xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm font-label">
              <i className="ri-book-open-line"></i>
              源自《水浒传》与《金瓶梅》的影视改编合集
            </span>

            <h1 className="mt-6 font-heading text-3xl md:text-5xl leading-tight text-background-50 font-bold">
              潘金莲电影
              <span className="block mt-2 text-xl md:text-3xl font-medium text-accent-300">
                从题材影视剧到系列电影与电视剧版的合集导览
              </span>
            </h1>

            <p className="mt-6 max-w-3xl mx-auto text-sm md:text-base leading-relaxed text-background-200/90">
              本站把“潘金莲电影”整理成一个可浏览的题材合集方向：先说明合集包含哪些内容，
              再依次梳理潘金莲题材影视剧、系列电影与电视剧版，帮助你在一页之内找到想看、想找的那一类作品。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              {quickLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm bg-background-50/10 text-background-50 border border-background-50/25 hover:bg-primary-500 hover:border-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className={link.icon}></i>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}